export default "__VITE_ASSET__6ada7c29__"